/* =========================================================
   ASTRAL'AURA : LA MUSIQUE D'AMBIANCE DE LA BOUTIQUE
   La même ambiance que sur astral-aura.fr, fabriquée en
   direct par le navigateur (Web Audio API), sans fichier audio :
   - une nappe grave et douce qui "respire"
   - quelques notes d'étoiles qui tintent au hasard
   - un carillon quand une pierre est ajoutée au panier
   Le son est ACTIVÉ par défaut, mais les navigateurs
   interdisent de jouer du son avant le premier geste du
   visiteur : la musique démarre donc au premier clic.
   Le bouton de l'en-tête la coupe (choix mémorisé).
   Tout est dans une fonction "fermée" pour ne jamais gêner
   les scripts de Shopify et du thème.
========================================================= */

(function () {
    const NOTES_ETOILES = [880, 987.77, 1108.73, 1318.51, 1479.98];
    const NOTE_PANIER = 659.25; // Mi, la note du carillon d'ajout au panier

    let audio = null;
    let volumeGeneral = null;
    let reverb = null;
    let sonActif = lirePreferenceSon();
    let minuterieEtoiles = null;

    /* ---------------------------------------------------------
       1) LE BOUTON (ajouté dans l'en-tête, avant le panier)
    --------------------------------------------------------- */

    const boutonSon = document.createElement("button");
    boutonSon.type = "button";
    boutonSon.className = "header__icon astral-bouton-son link focus-inset";
    boutonSon.innerHTML =
        '<span class="astral-onde" aria-hidden="true"><span></span><span></span><span></span><span></span></span>';

    const panierIcone = document.getElementById("cart-icon-bubble");
    if (!panierIcone) {
        return; // pas d'en-tête sur cette page : pas de musique
    }
    panierIcone.parentNode.insertBefore(boutonSon, panierIcone);

    /* ---------------------------------------------------------
       2) LA MISE EN PLACE DU SON (une seule fois)
    --------------------------------------------------------- */

    // Une réverbération "maison", comme l'écho d'une salle en pierre
    function creerReverb() {
        const duree = 3;
        const tampon = audio.createBuffer(2, audio.sampleRate * duree, audio.sampleRate);
        for (let canal = 0; canal < 2; canal++) {
            const donnees = tampon.getChannelData(canal);
            for (let i = 0; i < donnees.length; i++) {
                donnees[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / donnees.length, 3);
            }
        }
        const convolution = audio.createConvolver();
        convolution.buffer = tampon;
        const volumeReverb = audio.createGain();
        volumeReverb.gain.value = 0.6;
        convolution.connect(volumeReverb);
        volumeReverb.connect(volumeGeneral);
        return convolution;
    }

    // La nappe : 4 notes graves filtrées, qui ondulent lentement
    function creerAmbiance() {
        const filtre = audio.createBiquadFilter();
        filtre.type = "lowpass";
        filtre.frequency.value = 500;
        const respiration = audio.createGain();
        respiration.gain.value = 0.05;

        [55, 82.41, 110, 164.81].forEach(function (frequence, i) {
            const oscillateur = audio.createOscillator();
            oscillateur.type = i % 2 === 0 ? "sine" : "triangle";
            oscillateur.frequency.value = frequence;
            oscillateur.detune.value = (Math.random() - 0.5) * 12;
            const volume = audio.createGain();
            volume.gain.value = 0.25 / (i + 1);
            oscillateur.connect(volume);
            volume.connect(filtre);
            oscillateur.start();
        });

        const lfoFiltre = audio.createOscillator();
        lfoFiltre.frequency.value = 0.05;
        const forceFiltre = audio.createGain();
        forceFiltre.gain.value = 300;
        lfoFiltre.connect(forceFiltre);
        forceFiltre.connect(filtre.frequency);
        lfoFiltre.start();

        const lfoVolume = audio.createOscillator();
        lfoVolume.frequency.value = 0.08;
        const forceVolume = audio.createGain();
        forceVolume.gain.value = 0.02;
        lfoVolume.connect(forceVolume);
        forceVolume.connect(respiration.gain);
        lfoVolume.start();

        filtre.connect(respiration);
        respiration.connect(volumeGeneral);
        respiration.connect(reverb);
    }

    function preparerAudio() {
        audio = new (window.AudioContext || window.webkitAudioContext)();
        volumeGeneral = audio.createGain();
        volumeGeneral.gain.value = 0;
        volumeGeneral.connect(audio.destination);
        reverb = creerReverb();
        creerAmbiance();
    }

    // Une cloche : une note et deux harmoniques "métalliques"
    function cloche(frequence, volume, delai) {
        const debut = audio.currentTime + (delai || 0);
        [1, 2.76, 5.4].forEach(function (multiple, i) {
            const oscillateur = audio.createOscillator();
            oscillateur.frequency.value = frequence * multiple;
            const enveloppe = audio.createGain();
            const duree = 2.5 / (i + 1);
            enveloppe.gain.setValueAtTime(0, debut);
            enveloppe.gain.linearRampToValueAtTime(volume / (i * 2 + 1), debut + 0.01);
            enveloppe.gain.exponentialRampToValueAtTime(0.0001, debut + duree);
            oscillateur.connect(enveloppe);
            enveloppe.connect(volumeGeneral);
            enveloppe.connect(reverb);
            oscillateur.start(debut);
            oscillateur.stop(debut + duree);
        });
    }

    function tintementEtoile() {
        cloche(NOTES_ETOILES[Math.floor(Math.random() * NOTES_ETOILES.length)], 0.025);
        minuterieEtoiles = setTimeout(tintementEtoile, 3000 + Math.random() * 5000);
    }

    /* ---------------------------------------------------------
       3) ACTIVER / COUPER
    --------------------------------------------------------- */

    function lirePreferenceSon() {
        try {
            return localStorage.getItem("astral-aura-son") !== "coupe";
        } catch (erreur) {
            return true;
        }
    }

    function enregistrerPreferenceSon(actif) {
        try {
            if (actif) {
                localStorage.removeItem("astral-aura-son");
            } else {
                localStorage.setItem("astral-aura-son", "coupe");
            }
        } catch (erreur) {
            // navigation privée : le choix vaut pour cette page seulement
        }
    }

    function afficherBouton() {
        const joue = sonActif && audio !== null && audio.state === "running";
        boutonSon.setAttribute("aria-pressed", sonActif);
        boutonSon.setAttribute("aria-label", sonActif ? "Couper la musique d'ambiance" : "Activer la musique d'ambiance");
        boutonSon.title = sonActif ? "Couper la musique" : "Activer la musique";
        boutonSon.classList.toggle("joue", joue);
    }

    function allumer() {
        if (!audio) {
            preparerAudio();
        }
        audio.resume().then(afficherBouton);
        volumeGeneral.gain.cancelScheduledValues(audio.currentTime);
        volumeGeneral.gain.setTargetAtTime(1, audio.currentTime, 0.7);
        clearTimeout(minuterieEtoiles);
        tintementEtoile();
    }

    function eteindre() {
        if (!audio) {
            return;
        }
        volumeGeneral.gain.cancelScheduledValues(audio.currentTime);
        volumeGeneral.gain.setTargetAtTime(0, audio.currentTime, 0.2);
        clearTimeout(minuterieEtoiles);
        setTimeout(function () {
            if (!sonActif || document.hidden) {
                audio.suspend().then(afficherBouton);
            }
        }, 1200);
    }

    boutonSon.addEventListener("click", function () {
        // Activé mais pas encore démarré : le visiteur veut l'entendre
        if (sonActif && (!audio || audio.state !== "running")) {
            retirerEcoute();
            allumer();
            return;
        }
        sonActif = !sonActif;
        enregistrerPreferenceSon(sonActif);
        if (sonActif) {
            allumer();
        } else {
            eteindre();
        }
        afficherBouton();
    });

    /* ---------------------------------------------------------
       4) LE DÉMARRAGE AU PREMIER GESTE (clic, toucher, touche)
    --------------------------------------------------------- */

    function premierGeste(event) {
        if (event.target.closest && event.target.closest(".astral-bouton-son")) {
            return; // c'est le bouton qui décide
        }
        retirerEcoute();
        if (sonActif) {
            allumer();
        }
    }

    function retirerEcoute() {
        ["pointerdown", "keydown", "touchstart"].forEach(function (type) {
            document.removeEventListener(type, premierGeste, true);
        });
    }

    ["pointerdown", "keydown", "touchstart"].forEach(function (type) {
        document.addEventListener(type, premierGeste, true);
    });

    // En pause quand on change d'onglet, reprise au retour
    document.addEventListener("visibilitychange", function () {
        if (!audio || !sonActif) {
            return;
        }
        if (document.hidden) {
            eteindre();
        } else {
            allumer();
        }
    });

    /* ---------------------------------------------------------
       5) LE CARILLON D'AJOUT AU PANIER
       Dawn annonce chaque ajout avec l'événement "cart-update".
    --------------------------------------------------------- */

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (evenement) {
            if (sonActif && audio && evenement && evenement.source === "product-form") {
                cloche(NOTE_PANIER, 0.12, 0.1);
            }
        });
    }

    afficherBouton();
})();
